export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6651.4c274737.jpg";